module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "margin-left": "110px"
    }
  }, [_c('div', {
    staticClass: "main_table",
    staticStyle: {
      "overflow-x": "auto",
      "width": "992px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "1",
      "border": "0"
    }
  }, [_c('div', {
    staticClass: "header_top"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "50%",
      "padding-left": "10px"
    }
  }, [_vm._v("Location Name: "), _c('b', [_vm._v(_vm._s(_vm.techchecklist.siteName))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    }
  }, [_vm._v("DATE: "), _c('b', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(this.selectedDate) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("SHIFT: "), _c('b', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.shift) + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("SI.No."), _c('b', [_vm._v(_vm._s("1"))])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("1.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Diesel/Water in DG set checked"), _c('b', {
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dgSet.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.dgSet.subList[0].value == "false") ? "No" : "Na") + " ")])])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("1.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v(" DG set started once in shift\t"), _c('b', {
    staticStyle: {
      "margin-left": "112px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dgSet.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.dgSet.subList[1].value == "false") ? "No" : "Na") + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "5"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("2.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Air compressor filter cleaned "), _c('b', {
    staticStyle: {
      "margin-left": "102px"
    }
  }, [_vm._v("\t" + _vm._s((_vm.techchecklist.airCompressor.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.airCompressor.subList[0].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("2.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Air compressor oil level checked "), _c('b', {
    staticStyle: {
      "margin-left": "75px"
    }
  }, [_vm._v("\t " + _vm._s((_vm.techchecklist.airCompressor.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.airCompressor.subList[1].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("2.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Air compressor receiver drained "), _c('b', {
    staticStyle: {
      "margin-left": "77px"
    }
  }, [_vm._v("\t " + _vm._s((_vm.techchecklist.airCompressor.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.airCompressor.subList[2].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "10%",
      "border": "1px solid #000",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("3.1\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "width": "40%",
      "border-bottom": "0px"
    }
  }, [_vm._v("Working Condition :")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "50%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "6"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.remarks.subList[0].natureOfAbnormality))])]), _vm._v(" "), _vm._m(6), _vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Dispenser filters drained\t  "), _c('b', {
    staticStyle: {
      "margin-left": "130px"
    }
  }, [_vm._v("\t" + _vm._s((_vm.techchecklist.dispenser.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[0].value == "false") ? "No" : "Na") + "\t\t")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Dispenser nozzles checked and cleaned  "), _c('b', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dispenser.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[1].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.4")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Condition of dispenser seals  "), _c('b', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v(" " + _vm._s((_vm.techchecklist.dispenser.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[2].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("3.5")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Ensure two hour reading of dispensers  "), _c('b', {
    staticStyle: {
      "margin-left": "27px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.dispenser.subList[3].value == "true") ? "Yes" : (_vm.techchecklist.dispenser.subList[3].value == "false") ? "No" : "Na") + " ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "50%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Cause: ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Cascade:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.remarks.subList[1].cause))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("4.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Check cascade leakage,if any "), _c('b', {
    staticStyle: {
      "margin-left": "88px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.cascade.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.cascade.subList[0].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("5.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Check power supply "), _c('b', {
    staticStyle: {
      "margin-left": "156px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.electrical.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.electrical.subList[0].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("5.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Energy meter/UPS seals "), _c('b', {
    staticStyle: {
      "margin-left": "125px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.electrical.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.electrical.subList[1].value == "false") ? "No" : "Na"))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Action Taken : ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("5.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Electrical Room lock checked "), _c('b', {
    staticStyle: {
      "margin-left": "91px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.electrical.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.electrical.subList[2].value == "false") ? "No" : "Na"))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "rowspan": "11"
    }
  }, [_vm._v(_vm._s(_vm.techchecklist.remarks.subList[2].actionTaken))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Tools handed over "), _c('b', {
    staticStyle: {
      "margin-left": "169px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[0].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Waste cloth availability on the station "), _c('b', {
    staticStyle: {
      "margin-left": "38px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[1].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Check DSM duty handed over "), _c('b', {
    staticStyle: {
      "margin-left": "86px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[2].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("6.4")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Take over log book "), _c('b', {
    staticStyle: {
      "margin-left": "164px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.general.subList[3].value == "true") ? "Yes" : (_vm.techchecklist.general.subList[3].value == "false") ? "No" : "Na"))])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("First Aid Box "), _c('b', {
    staticStyle: {
      "margin-left": "208px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[0].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[0].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Tool Box  "), _c('b', {
    staticStyle: {
      "margin-left": "236px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[1].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[1].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Adapter/Remote  "), _c('b', {
    staticStyle: {
      "margin-left": "180px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[2].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[2].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Oil/Coolant/Diesel  "), _c('b', {
    staticStyle: {
      "margin-left": "168px"
    }
  }, [_vm._v(_vm._s((_vm.techchecklist.assets.subList[3].value == "true") ? "Yes" : (_vm.techchecklist.assets.subList[3].value == "false") ? "No" : "Na") + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "padding": "50px 0px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("Details of Breakdown/power cut & DG set running hours : " + _vm._s(_vm.techchecklist.additionalInfo.subList[0].dgSetRunningHour) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "padding": "50px 0px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("Instructions received from control room in the shift : " + _vm._s(_vm.techchecklist.additionalInfo.subList[1].instructionReceived))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "padding": "50px 0px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v("Other Information for next shift Technician : " + _vm._s(_vm.techchecklist.additionalInfo.subList[2].otherInformation))])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Name :"), _c('b', [_vm._v(_vm._s(_vm.techchecklist.operatorName))])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Signature : " + _vm._s(_vm.techchecklist.sign))])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-13 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'OperatorReport'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "right",
      "padding-right": "10px"
    }
  }, [_vm._v("Doc No: "), _c('b', [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "24px",
      "border": "1px solid #000",
      "width": "56%",
      "padding-left": "10px",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("TECHNICIAN LOG BOOK/CHECK LIST")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "border": "1px solid #000",
      "text-align": "center",
      "padding-left": "10px"
    }
  }, [_vm._v("S.NO.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "center",
      "padding-left": "10px"
    }
  }, [_vm._v("TASK TO BE CARRIED OUT")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "center",
      "font-weight": "bold",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px"
    }
  }, [_vm._v("REMARKS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" DG Set:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px",
      "font-weight": "bold"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Abnormality/Breakdown reported to (if any,in Dispenser,Cascade,DG set,UPS,Air Compressor,etc):\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Air Compressor:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Dispenser:\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "text-align": "left",
      "width": "50%",
      "border": "1px solid #000",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Nature of Abnormality/Breakdown :  \t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0px",
      "border-right": "0",
      "width": "45%",
      "padding-left": "10px",
      "border-left": "0px"
    }
  }, [_vm._v("Dispenser - 1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "width": "65%",
      "border": "1px solid #000",
      "border-top": "0",
      "border-left": "0px",
      "border-right": "0px"
    }
  }, [_vm._v("Side - A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0",
      "text-align": "center",
      "padding-left": "10px",
      "border-right": "0px",
      "border-left": "0px",
      "border-bottom": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Side - B")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0px",
      "border-right": "0",
      "width": "45%",
      "padding-left": "10px",
      "border-left": "0px"
    }
  }, [_vm._v("Dispenser - 2")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "width": "65%",
      "border": "1px solid #000",
      "border-top": "0",
      "border-left": "0px",
      "border-right": "0px"
    }
  }, [_vm._v("Side - A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "border-top": "0",
      "text-align": "center",
      "padding-left": "10px",
      "border-right": "0px",
      "border-left": "0px",
      "border-bottom": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Side - B")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Electrical / UPS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("General:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    },
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "40%",
      "text-align": "left",
      "padding-left": "10px"
    }
  }, [_vm._v("Assets:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px",
      "height": "21px"
    },
    attrs: {
      "colspan": "3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px",
      "font-weight": "bold"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Technician-In-Charge  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "16px",
      "border": "1px solid #000",
      "width": "100%",
      "text-align": "left",
      "padding-left": "10px",
      "height": "21px"
    },
    attrs: {
      "colspan": "3"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c6d8c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/operatorReport/ViewOperatorReport.vue
// module id = 1947
// module chunks = 1